import { useState } from 'react';
import { useQueryClient } from '@tanstack/react-query';

import {
  usePostSymptomQuestion,
  useUpdateSymptomQuestion,
} from 'services/symptom-checker/hooks';
import { SymptomQuestionResponse } from 'services/symptom-checker/type';
import { SymptomCheckerParams } from 'types/symptom';
import { useSymptomStore } from 'store/symptom';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PATH_ROUTES } from 'routes/path';

interface SubmitProps {
  questionData: SymptomCheckerParams;
  eng_choices: string;
  spanish_choices: string;
}

export default function useSymptomChecker() {
  const queryClient = useQueryClient();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const code = searchParams.get('code');

  const [isUpdating, setIsUpdating] = useState(false);

  const setQuestionData = useSymptomStore((store) => store.setQuestionData);

  const { mutateAsync: postQuestion } = usePostSymptomQuestion();
  const { mutateAsync: updateQuestion } = useUpdateSymptomQuestion();

  const symptomCheckerNavigation = (
    response: SymptomQuestionResponse,
    isEdit?: boolean
  ) => {
    if (response?.is_follow) {
      const questionItem = response?.data?.q_id ? response.data : null;

      if (questionItem?.code) {
        // const nextRoute = SymptomCodeScreenMapper[questionItem.code];
        // navigation.dispatch(
        //   StackActions.replace(nextRoute, { ...questionItem, isEdit })
        // );
      }
      return;
    }

    if (response?.screen === 'review') {
      // const nextRoute = SymptomCodeScreenMapper.review;
      // return navigation.dispatch(
      //   StackActions.replace(nextRoute, response.data)
      // );
      return;
    }

    const questionItem = response?.data?.q_id ? response.data : null;

    queryClient.invalidateQueries({
      queryKey: ['symptom-checker'],
    });

    if (isEdit) {
      // return navigation.goBack();
      return;
    }

    if (questionItem?.code) {
      // const nextRoute = SymptomCodeScreenMapper[questionItem.code];
      // navigation.dispatch(StackActions.replace(nextRoute, questionItem));
    }
  };

  const onSubmit = async ({
    questionData,
    eng_choices,
    spanish_choices,
  }: SubmitProps) => {
    setIsUpdating(true);
    try {
      const payloadData = {
        eng_choices,
        spanish_choices,
        answer_id: questionData?.answer_id || null,
        q_id: questionData?.q_id || '',
      };
      const isEdit = questionData?.isEdit || code;
      const response = isEdit
        ? await updateQuestion(payloadData)
        : await postQuestion(payloadData);

      const questionItem = response?.data?.q_id ? response.data : null;
      console.log('🚀 ~ onSubmit ~ questionItem:', questionItem);

      if (response?.is_follow) {
        if (questionItem?.code) {
          setQuestionData(response);
        }
        return;
      }

      if (isEdit) {
        return navigate(-1);
      }

      if (response.screen === 'review') {
        setQuestionData(response);
        return navigate(PATH_ROUTES.GENERATE_SYMPTOM_REVIEW);
      }

      if (!questionItem) {
        navigate(PATH_ROUTES.SYMPTOM_CHECKER);
        return;
      }

      setQuestionData(response);

      // symptomCheckerNavigation(res, questionData?.isEdit);
    } catch (error) {
      console.log(error);
    } finally {
      setIsUpdating(false);
    }
  };
  return { onSubmit, isLoading: isUpdating, symptomCheckerNavigation };
}
